import { useNavigate } from 'react-router-dom';
import { PrimaryButton } from '../components/ui/Button/Buttons';
import { PATHS } from '../constants/Paths.constants';
import { AccessDeniedIcon } from '../icons/SvgIcons';

export function AccessDenied() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen min-w-screen flex items-center justify-center bg-white">
      <div className="flex flex-row gap-6 text-left">
        {AccessDeniedIcon()}
        <div className="flex flex-col items-start w-[480px] pl-6">
          <h1 className="text-[30px] leading-[36px] font-bold text-purple-900">
            Access denied
          </h1>
          <p className="text-base text-gray-500 mb-10">
            You don’t have permission to access this page.
          </p>
          <PrimaryButton
            onClick={() => navigate(PATHS.DASHBOARD)}
          >
            Go to Dashboard
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}

